//@ts-nocheck
import { Box, CircularProgress } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
import ParentForm from "../parent-flow/forms/ParentForm";
import { FormContainer } from "./components/FormWrapper";
import { FFormContext } from "../../primitives/forms/FormField";
import contactInfoJson from "./contactInfo.json";

export const LoadingStateForRequest = ({ text = "Retrieving tutors..." }) => {
  const [textColor, setTextColor] = React.useState("neutral.700");
  const [loadingColor, setLoadingColor] = React.useState("gray");

  setTimeout(() => {
    if (textColor === "neutral.700") {
      setTextColor("blue.500");
      setLoadingColor("blue");
    }
    if (textColor === "blue.500") {
      setTextColor("green.500");
      setLoadingColor("green");
    }
    if (textColor === "green.500") {
      setTextColor("red.500");
      setLoadingColor("red");
    }

    if (textColor === "red.500") {
      setTextColor("neutral.700");
      setLoadingColor("gray");
    }
  }, 500);

  return (
    <Box h="100%" justifyContent="center" mt="20%">
      <Box textAlign="center">
        <CircularProgress
          size="120px"
          thickness={0.1}
          isIndeterminate
          color={loadingColor}
        />
        <Box color={textColor} fontFamily="Helvetica" fontSize="24px" mt={2}>
          {text}
        </Box>
      </Box>
    </Box>
  );
};

type ParentFormPageProps = {
  onSubmit: any;
  loading?: boolean;
  toPreviousPage?: any;
  viewModel: any;
  loadingText: string;
  country?: string;
  country_code?: string;
  [key: string]: any;
};

const ParentFormPage: React.FC<ParentFormPageProps> = observer(
  ({
    onSubmit = () => {},
    loading,
    toPreviousPage = () => {},
    viewModel,
    country,
    country_code,
    loadingText,
    ...props
  }) => {
    const formCopy = {
      heading: "How do we contact you?",
      description:
        "We'll send progress reports and details about your lessons. Only your name and phone will be shared with your tutor.",
    };
    return (
      <FormContainer {...formCopy} {...props}>
        <FFormContext.Provider
          value={{
            placeholders: contactInfoJson.placeholders,
          }}
        >
          <ParentForm
            viewModel={viewModel}
            onSubmit={onSubmit}
            countryName={country}
            countryCode={country_code}
            loading={loading}
            loadingText={loadingText}
            onBackClick={toPreviousPage}
          />
        </FFormContext.Provider>
      </FormContainer>
    );
  }
);

export default ParentFormPage;
